module.exports = __webpack_public_path__ + "img/kommune-1516.82be18bc.svg";